export default {
  namespaced: true,
  state() {
    return {
      fieldWithError: '',
    };
  },
  mutations: {
    setFieldWithError(state, payload) {
      state.fieldWithError = payload;
    },
  },
};
